import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class HotSpotZoomService {
    zoomToPoint(element: HTMLElement, x: number, y: number, zoom: number): void {
        const zoomToX = (element.clientWidth / 2 - (element.clientWidth * x) / 100) * zoom;
        const zoomToY = (element.clientHeight / 2 - (element.clientHeight * y) / 100) * zoom;
        element.classList.add('image-is-zooming');
        element.style.transform = 'translate(' + zoomToX * zoom + 'px, ' + zoomToY * zoom + 'px) ' + 'scale(' + zoom + ')';
    }

    unzoom(element: HTMLElement): void {
        element.style.transform = null;
        element.classList.remove('image-is-zooming');
    }
}
